import Button from "../../../lib/components/Button";

export default function ChunkLoadErrorFallback() {
  return (
    <main className="flex flex-col justify-center items-center space-y-8 w-screen h-screen">
      <section className="flex flex-col items-center space-y-2">
        <p className="font-sans text-2xl font-bold text-secondary-dark-300">
          This page did not finish loading
        </p>
        <p className="font-serif text-base tracking-tight text-secondary-dark-200">
          Your connection may have dropped. Refresh the page to try again.
        </p>
      </section>
      <Button
        onClick={() => {
          window.location.reload();
        }}
        label="Refresh"
        size="base"
      />
    </main>
  );
}
